<template>
  <div
    ref="container"
    class="relative select-none border-solid rounded-lg bg-grey-800 text-grey-100 border-grey-700 gp-color-picker"
    :class="{
      'w-full': plugin,
      'h-8 flex flex-grow border': !expanded
    }"
  >
    <div
      v-if="!expanded"
      class="w-full h-full flex flex-row cursor-pointer"
      @click="toggleMenu()"
    >
      <div
        class="flex flex-grow h-full rounded-l-lg"
        :style="{ backgroundColor: value }"
      ></div>
      <div class="text-grey-500 flex justify-center h-full bg-grey-900 rounded-r-lg border-solid border-l border-grey-700 w-8">
        <arrow-down
          class="h-4 w-4 fill-current absolute top-0 mt-2"
        ></arrow-down>
      </div>
    </div>
    <color-picker-menu
      v-if="menuOpen || expanded"
      :value="value"
      :expanded="expanded"
      :align="align"
      :colors="colors"
      :right-side="rightSide"
      :floating="floating"
      @close="closeMenu"
      @change="setValue"
      :cookies-origin="cookiesOrigin"
    />
  </div>
</template>

<script>
import ArrowDown from '@fortawesome/fontawesome-free/svgs/solid/angle-down.svg';
import ColorPickerMenu from '@groovepages/gd-ui-kit/components/ColorPickerMenu';
import directives from '../directives';

export default {
  name: 'ColorPicker',
  components: {
    ArrowDown,
    ColorPickerMenu
  },
  directives,
  props: {
    plugin: {
      type: Boolean,
      default: false
    },
    colors: {},
    opacities: {
      default: () => [...Array(101).keys()].map(value => value / 100)
    },
    value: {},
    expanded: {},
    align: {
      type: String,
      default: null
    },
    floating: {
      default: false
    },
    quill: {},
    cookiesOrigin: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menuOpen: false,
      rightSide: false
    };
  },
  methods: {
    setValue(color) {
      this.$emit('input', color);
      this.$emit('change', color);
    },
    toggleMenu() {
      if (this.$refs.container.getBoundingClientRect().left < 224) {
        this.rightSide = true;
      } else this.rightSide = false;
      try {
        this.menuOpen = !this.menuOpen;
      } catch (e) {
        this.resetVerte();
        this.menuOpen = !this.menuOpen;
      }
    },
    closeMenu() {
      this.menuOpen = false;
    }
  }
};
</script>
